/**
 * Layout/index.js
 * desc: page layout — the full-height Sidebar beside a column of the Header and the page content
 * note: the page (the Outlet) renders inside the content column
 */
'use strict';

import Header from '../Header';
import Sidebar from '../Sidebar';
import { Outlet } from "react-router";
import LocationChangePrompt from '../../components/LocationChangePrompt';
import './styles.css';


const Layout = ({ children }) => (
    <div id="layout" data-testid="app-shell">
        <Sidebar/>
        <div className="main">
            <Header/>
            <div className="content">
                <LocationChangePrompt />
                <Outlet />
                { children }
            </div>
        </div>
    </div>
);


export default Layout;
